import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-types-papi';
import FavStarFillIcon from '@wix/da-shared-react/pkg/Icons/16x16/FavStarFill';
import { IconSize } from '@wix/da-shared-react/pkg/Icons/IconWrap';
import TextTooltipOnHover from '@wix/da-shared-react/pkg/Popover/TextTooltipOnHover';
import { MobileContext } from '@wix/da-shared-react/pkg/Context';

import s from './FavouritesLabel.scss';

export interface Props {
  className?: string;
  tooltipUser?: PapiUser;
}

const FavouritesLabel: React.FC<Props> = ({ className, tooltipUser }) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const tooltipText =
    tooltipUser &&
    t('common.favourites_tooltip', {
      username: tooltipUser.username,
    });

  const label = (
    <>
      <FavStarFillIcon
        className={s['icon']}
        disableDefaultColors={true}
        size={IconSize.TINY}
      />{' '}
      {t('common.favourites_plural')}
    </>
  );

  return (
    <div className={classnames(s['root'], className)}>
      {!isMobile && tooltipText ? (
        <TextTooltipOnHover tooltipText={tooltipText}>
          {label}
        </TextTooltipOnHover>
      ) : (
        label
      )}
    </div>
  );
};
FavouritesLabel.displayName = 'FavouritesLabel';

export default FavouritesLabel;
